export default class ShowHide {
  constructor(el) {
    this.el = el;

    const items = el.querySelectorAll('[data-showhide-item]');

    if (items && !!items.length) {
      items.forEach((item) => {
        const trigger = item.querySelector('[data-showhide-control]');

        if (trigger) trigger.addEventListener('click', this.handleClicks);
      });
    } else {
      const trigger = el.querySelector('[data-showhide-control]');

      if (trigger) trigger.addEventListener('click', this.handleClicks);
    }
  }

  handleClicks(event) {
    const trigger = event.target;
    const contentContainer = trigger.parentNode.nextElementSibling;
    const content = contentContainer.querySelector('[data-showhide-content]');
    const indicator = trigger.querySelector('[data-showhide-indicator]');

    console.log('contentContainer', contentContainer);
    console.log('content', content);
    console.log('indicator', indicator);

    event.preventDefault();

    if (trigger.getAttribute('aria-expanded') === 'false') {
      trigger.setAttribute('aria-expanded', true);
      content.removeAttribute('aria-hidden');
      if (indicator) indicator.classList.add('rotate-180');
      contentContainer.style.height = `${content.offsetHeight + 16}px`;
    } else {
      trigger.setAttribute('aria-expanded', false);
      content.setAttribute('aria-hidden', true);
      if (indicator) indicator.classList.remove('rotate-180');
      contentContainer.style.height = null;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ShowHide.js